import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { parseTranslationKey } from '@/js/libs/i18n-tools';

import type { TrackedTranslation } from '../types.ts';

type UseTranslationDataResult = {
  translations: TrackedTranslation[];
};

export function useTranslationData(trackedKeys: string[]): UseTranslationDataResult {
  const [t] = useTranslation();

  const translations = useMemo<TrackedTranslation[]>(() => {
    return trackedKeys.map((fullKey) => {
      const { namespace, key } = parseTranslationKey(fullKey);
      // eslint-disable-next-line rulesdir/key-format -- reads back a key the screen rendered, which names its namespace
      const value = t(fullKey, { postProcess: [] });

      return {
        fullKey,
        namespace,
        key,
        value: typeof value === 'string' ? value : fullKey,
      };
    });
  }, [trackedKeys, t]);

  return {
    translations,
  };
}
